import { Box } from '@shape-ds/components';
import React from 'react';

interface SectionBoxProps {
  sections: string[];
  getTitle?: (sectionKey: string) => string;
  renderSectionContent: (sectionKey: string) => JSX.Element | null;
}

const SectionBox: React.FC<SectionBoxProps> = ({ sections, getTitle, renderSectionContent }) => {
  return (
    <>
      {sections.map((sectionKey) => (
        <Box className={`${sectionKey}`} key={sectionKey}>
          {getTitle && <h2>{getTitle(sectionKey)}</h2>}
          {renderSectionContent(sectionKey)}
        </Box>
      ))}
    </>
  );
};

export default SectionBox;
